module.exports = __webpack_public_path__ + "static/media/to_east-night.a67d1c64.jpg";